import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { Manager, UserProfile } from '@pt/models';
import { environment } from '@pt/environment';

@Component({
  selector: 'pu-user-profile-card',
  standalone: false,
  template: `
    <pu-profile-card
      [user]="user()"
      [colorfulAvatar]="colorfulAvatar()"
      [hasEmail]="hasEmail()"
      [redirectToUserProfileAllowed]="redirectToUserProfileAllowed()"
      [optimizationEnabled]="true"
      [hexagonalDesignEnabled]="hexagonalDesignEnabled"
      (userClick)="navigateToUserProfile($event)"
    >
      <ng-content/>
    </pu-profile-card>
  `,
})
export class UserProfileCardComponent {
  user = input<UserProfile | Manager>();
  colorfulAvatar = input(false);
  hasEmail = input(true);
  redirectToUserProfileAllowed = input(false);

  readonly #router = inject(Router);
  readonly hexagonalDesignEnabled = false;
  readonly optimizationEnabled = environment.imagesOptimizationEnabled;

  navigateToUserProfile(userId: number): void {
    this.#router.navigateByUrl('/colleague/' + userId);
  }
}
